module.exports = __webpack_public_path__ + "img/login.2efe5541.png";